import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SignupForm } from "@baseline/web/components/auth/SignupForm";

export const Route = createFileRoute("/signup")({
	component: Signup,
});

function Signup() {
	const navigate = useNavigate();

	return (
		<SignupForm
			onSuccess={() =>
				navigate({
					to: "/",
					search: {
						mode: undefined,
						tag: undefined,
						type: undefined,
						summary: undefined,
					},
				})
			}
			loginUrl="/login"
		/>
	);
}
